export const PERMS = {
    READ: 'trailer_documents.read',
    UPDATE: 'trailer_documents.update',
    DELETE: 'trailer_documents.delete',
    CREATE: 'trailer_documents.create',
    EXPORT: 'trailer_documents.export',
}
